import React from 'react';

/**
 * Pantalla que se muestra cuando el veterinario no tiene acceso
 * (sin pacientes Premium activos y período de gracia expirado)
 */
const AccesoBloqueado = () => {
  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh',
        backgroundColor: '#f5f5f5',
        padding: '20px'
      }}
    >
      <div
        style={{
          backgroundColor: 'white',
          borderRadius: '16px',
          boxShadow: '0 4px 20px rgba(0, 0, 0, 0.1)',
          maxWidth: '500px',
          width: '100%',
          textAlign: 'center',
          padding: '48px 32px'
        }}
      >
        {/* Icon */}
        <div style={{ fontSize: '64px', marginBottom: '24px' }}>
          <span role="img" aria-label="lock">🔒</span>
        </div>

        {/* Title */}
        <h2
          style={{
            color: '#374151',
            fontSize: '24px',
            fontWeight: '600',
            marginBottom: '16px'
          }}
        >
          Acceso suspendido
        </h2>

        {/* Description */}
        <p
          style={{
            color: '#6b7280',
            fontSize: '16px',
            marginBottom: '24px',
            lineHeight: '1.6'
          }}
        >
          No tienes pacientes LemmonTags activos.
        </p>

        <p
          style={{
            color: '#374151',
            fontSize: '15px',
            marginBottom: '32px',
            lineHeight: '1.6'
          }}
        >
          Tu acceso se restaurará automáticamente cuando un cliente Premium te invite nuevamente.
        </p>

        {/* Divider */}
        <hr
          style={{
            border: 'none',
            borderTop: '1px solid #e5e7eb',
            margin: '24px 0'
          }}
        />

        {/* Independent plan option */}
        <p
          style={{
            color: '#374151',
            fontSize: '15px',
            fontWeight: '600',
            marginBottom: '16px'
          }}
        >
          ¿Quieres operar de forma independiente?
        </p>

        <a
          href="mailto:soporte@lemmontags.com?subject=Plan%20Veterinario%20Independiente"
          style={{
            display: 'inline-block',
            backgroundColor: '#84cc16',
            color: 'white',
            padding: '14px 32px',
            borderRadius: '8px',
            textDecoration: 'none',
            fontWeight: '500',
            fontSize: '16px',
            transition: 'background-color 0.2s'
          }}
          onMouseOver={(e) => e.target.style.backgroundColor = '#65a30d'}
          onMouseOut={(e) => e.target.style.backgroundColor = '#84cc16'}
        >
          Contactar a soporte
        </a>

        {/* Footer info */}
        <p
          style={{
            color: '#9ca3af',
            fontSize: '13px',
            marginTop: '32px'
          }}
        >
          Si crees que esto es un error, contacta a soporte.
        </p>
      </div>
    </div>
  );
};

export default AccesoBloqueado;
